export default __webpack_public_path__ + "static/media/idfc_first_logo.826bc630.webp";